'use client';

import { useState, useEffect } from 'react';

import { Dialog, DialogContent } from '@mui/material';

import { ActionTypes, useAppContext } from 'src/contexts/AppContext';

import RenderDialog from 'src/sections/generate-page/components/popups';

import { BasicPageParams } from 'src/types/common';

import { BlockType } from '../../types/generator';
import { useContentContext } from '../../components/content';

// ----------------------------------------------------------------------

type Props = {
  popups: BlockType[];
  params: BasicPageParams;
};

// ----------------------------------------------------------------------

// TODO: слоты для заголовка (Title) и кнопок действий (Action Buttons)
export default function Dialogs({ popups, params }: Props) {
  const { closeSiteByDate, expirationDate } = useContentContext();
  const { state, dispatch } = useAppContext();
  const { activeDialog } = state;
  const [giveToClose, setGiveToClose] = useState(true);
  const { allContentAuth } = useContentContext();
  const setActiveDialog = (payload: null | string) => {
    dispatch({ type: ActionTypes.SET_ACTIVE_DIALOG, payload });
  };

  useEffect(() => {
    if (closeSiteByDate && expirationDate) {
      const now = new Date();
      const expiration = new Date(expirationDate);

      if (now > expiration || allContentAuth) {
        setGiveToClose(false);
      } else setGiveToClose(true);
    }
    if (allContentAuth) setGiveToClose(false);
  }, [closeSiteByDate, expirationDate, allContentAuth]);

  return (
    !!popups.length &&
    popups.map((popupBlock, idx) => (
      <Dialog
        maxWidth={(popupBlock?.settings?.modalSize as 'xs' | 'sm' | 'md' | 'lg' | 'xl') || 'xs'}
        sx={{ '& .MuiPaper-root': { width: '100%' } }}
        open={popupBlock.modalId === activeDialog}
        key={`dialog_${idx}`}
        onClose={() => (giveToClose ? setActiveDialog(null) : {})}
      >
        <DialogContent>
          <RenderDialog block={popupBlock} params={params} />
        </DialogContent>
      </Dialog>
    ))
  );
}
